import React, {FC, useState} from "react"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Button from "@irati/ui/src/Button"

interface Props extends InjectIntl {
  report?: string
}

const ShareLink: FC<Props> = (props) => {
  const [showCopied, setCopied] = useState<boolean>(false)
  const {formatMessage, report} = props

  const handleClick = () => {
    const pathname = `${window.location.origin}${window.location.pathname}`
    const urlToCopy = report ? `${pathname}?report=${report}` : pathname
    navigator.clipboard.writeText(urlToCopy)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Button id={showCopied ? "adminSection_copiedURL_button" : "adminSection_shareReport_button"} small onClick={handleClick}>
      {showCopied ? (
        formatMessage({id: "admin.components.shareLink.copy"})
      ) : (
        <>
          <Icon icon={IconTypes.share} small marginRight={0.5} />
          <FormattedMessage id="admin.components.shareLink.text" />
        </>
      )}
    </Button>
  )
}

export default injectIntl(ShareLink)
